
import { defineComponent } from "vue";
import FeatureCard from "./FeatureCard.vue";
import { featureWallList } from "../../config/featureWall";

export default defineComponent({
    name: "FeatureWall",
    props: {
    
    },
    data() {
        return {
            featureWallList
        };
    },
    components: {
        FeatureCard
    }
});
